export default __webpack_public_path__ + "static/media/doc.4b0cb9cf.svg";